import { StaticPropertyKey } from '@bvi/api-interfaces/entity/case-property';
import { ManageBaseDataKeys } from '@bvi/api-interfaces/entity/manage-base';

const SEARCH_PARAM_BY_TYPE: Record<ManageBaseDataKeys, string> = {
  [ManageBaseDataKeys.SUBSIDIARIES]: StaticPropertyKey.DIOCESE,
  [ManageBaseDataKeys.ORGANIZATIONS]: StaticPropertyKey.ORGANIZATION,
  [ManageBaseDataKeys.ORGANIZATION_TYPES]: StaticPropertyKey.ORGANIZATION_TYPE,
  [ManageBaseDataKeys.PERPETRATORS]: StaticPropertyKey.PERPETRATOR,
  [ManageBaseDataKeys.DEFENSES]: StaticPropertyKey.LIABILITY_DEFENSES,
  [ManageBaseDataKeys.EXCEPTIONS]: StaticPropertyKey.EXCEPTION,
  [ManageBaseDataKeys.JOB_POSITIONS]: StaticPropertyKey.JOB_TITLE,
  [ManageBaseDataKeys.ORDERS]: StaticPropertyKey.ORDER,
  [ManageBaseDataKeys.DAMAGES]: StaticPropertyKey.DAMAGE,
  [ManageBaseDataKeys.COUNTRIES]: StaticPropertyKey.COUNTRY,
};

export const getViewCasesSearchParameters = (
  type: ManageBaseDataKeys,
  id: number,
) => ({
  page: 1,
  limit: 100,
  [SEARCH_PARAM_BY_TYPE[type]]: id,
  'exclude-organization': false,
  'exclude-subsidiary': false,
});
